import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";

import FormPrompt from "../DailogBoxes/formprompt";
import { searchTextRegex } from "../../constant/regex";
import AlertDialogBox from "../DailogBoxes/alertdailogbox";
import ConfirmDialogBox from "../DailogBoxes/confirmdailogbox";
import ErorrDialogBox from "../DailogBoxes/errordaologbox";
import Service from "../../Service/firebase";
import AddUser from "./adduser";
import { setuser } from "../../actions/setuseraction";

import "./userlist.css";
const UserList = (props) => {
  const [searchText, setSearchText] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [limit, setLimit] = useState(10);
  const [isLoadMoreData, setIsLoadMoreData] = useState(false);
  const [isCloseBtnAppear, setIsCloseBtnAppear] = useState(true);
  const [isDeleting, setIsDeleting] = useState(false);
  const [totalNumOfUser, setTotalNumOfUser] = useState(null);
  const [noMoreDataText, setNoMoreDataText] = useState("");
  const [openFormDailog, setOpenFormDailog] = useState(false);
  const [openAlertDailog, setOpenAlertDailog] = useState(false);
  const [openErrorDailog, setOpenErrorDailog] = useState(false);
  const [openConfirmDailog, setOpenConfirmDailog] = useState(false);
  const [UserList, setUserList] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [isSearchDataShow, setIsSearchDataShow] = useState(false);
  const [selectedUserName, setSelectedUserName] = useState("");
  const [selectedUserId, setSelectedUserId] = useState("");

  useEffect(() => {
    let isSubscribed = true;
    if (isSubscribed) {
      onSetTotalNumOfUser();
      onFetchData(limit);
    }
    return () => {
      isSubscribed = false;
    };
  }, []);

  const showMore = () => {
    if (limit <= totalNumOfUser) {
      const limitNew = limit + 10;
      setLimit(limitNew);
      onFetchData(limitNew);
    } else {
      setNoMoreDataText("No MoreCategory");
    }
  };
  const onSetTotalNumOfUser = async () => {
    setIsLoading(true);
    const res = await Service.getTotalNumOfPerson("users");
    if (res === "error") {
      console.log("error");

      setIsLoading(false);
    } else {
      setTotalNumOfUser(res);
      setIsLoading(false);
    }
  };

  const onFetchData = async (limit) => {
    setIsLoadMoreData(true);

    const fetchedDataList = await Service.getData("users", limit);

    if (fetchedDataList.length !== 0) {
      setUserList(fetchedDataList);
      setIsLoadMoreData(false);
      setIsLoading(false);
    } else {
      setUserList(fetchedDataList);
      setIsLoadMoreData(false);
      setIsLoading(false);
    }
  };

  const handleOnDelete = (userName, id) => {
    setSelectedUserName(userName);
    setSelectedUserId(id);
    setOpenConfirmDailog(true);
  };
  const deleteData = async () => {
    setIsDeleting(true);
    const res = await Service.deleteData("users", selectedUserId);
    if (res === "success") {
      setIsDeleting(false);
      setOpenConfirmDailog(false);
      window.location.reload(false);
    } else {
      setIsDeleting(false);
      handleErrorDailog();
    }
  };
  const handleSearch = async () => {
    if (searchText === "" || null) {
      window.location.reload(false);
    } else {
      setIsSearching(true);
      setIsSearchDataShow(true);

      const searchTextWithRegex = searchText
        .toLowerCase()
        .replace(searchTextRegex, "");

      const resultUserList = await Service.getSearchRes(
        "users",
        searchTextWithRegex
      );
      if (resultUserList === "error") {
        setIsSearching(true);
        setOpenErrorDailog(true);
      } else {
        setUserList(resultUserList);
        setIsSearching(false);
      }
    }
  };

  const handleSuccessDailog = () => {
    setOpenFormDailog(false);
    setOpenAlertDailog(true);
  };
  const handleErrorDailog = () => {
    setOpenFormDailog(false);
    setOpenConfirmDailog(false);
    setOpenErrorDailog(true);
  };
  const closeFormDailog = () => {
    setOpenFormDailog(false);
  };
  const closeAlertDailog = () => {
    setOpenAlertDailog(false);
    window.location.reload(false);
  };
  const closeErrorDailog = () => {
    setOpenErrorDailog(false);
  };
  const closeConfirmDailog = () => {
    setOpenConfirmDailog(false);
  };
  const setCloseBtnAppear = () => {
    setIsCloseBtnAppear(false);
  };

  console.log(UserList);
  let count = 0;
  return isLoading ? (
    <div className="userlistpage">
      <i className="fas fa-spinner fa-pulse fa-2x "></i>
    </div>
  ) : (
    <div className="userlistpage">
      <div className="main_section">
        <ConfirmDialogBox
          openDailog={openConfirmDailog}
          onSetOpenDailog={closeConfirmDailog}
          handleConfirmOkBtn={deleteData}
          isLoading={isDeleting}
          title="Delete"
          des={"Are you sure to delete " + selectedUserName + " " + "details"}
        ></ConfirmDialogBox>
        <AlertDialogBox
          openDailog={openAlertDailog}
          onSetOpenDailog={closeAlertDailog}
          title="Added"
          des="New User has been added successfully"
        ></AlertDialogBox>
        <ErorrDialogBox
          openDailog={openErrorDailog}
          onSetOpenDailog={closeErrorDailog}
          title="Error"
          des="Someting went wrong. Try again"
        ></ErorrDialogBox>

        <FormPrompt
          openDailog={openFormDailog}
          title="Add New User"
          onSetOpenDailog={closeFormDailog}
          isCloseBtnAppear={isCloseBtnAppear}
        >
          <AddUser
            setCloseBtnAppear={setCloseBtnAppear}
            handleSuccessDailog={handleSuccessDailog}
            handleErrorDailog={handleErrorDailog}
            collectionName="users"
            id="userid"
          ></AddUser>
        </FormPrompt>

        <div className="topheader">
          <ul>
            <li>
              <i
                className="fa fa-arrow-circle-o-right fa-2x"
                aria-hidden="true"
              ></i>
            </li>
            <li>
              <h5>User</h5>
            </li>
          </ul>
        </div>
        <hr />
        <div className="top_section">
          <div className="wrap">
            <ul>
              <li>
                <div className="search">
                  <input
                    type="text"
                    className="searchTerm"
                    placeholder="Search User by  name"
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleSearch();
                      }
                    }}
                    onChange={(e) => {
                      setSearchText(e.target.value);
                    }}
                  />

                  <button
                    onClick={handleSearch}
                    type="submit"
                    className="searchButton"
                  >
                    <i className="fa fa-search"></i>
                  </button>
                </div>
              </li>
              <li style={{ fontSize: "12px" }}> #</li>
              <li style={{ fontSize: "12px" }}>{UserList.length} </li>
            </ul>
          </div>

          <button
            type="button"
            className="btn btn-warning"
            onClick={() => {
              setOpenFormDailog(true);
            }}
          >
            + Add User
          </button>
        </div>
        <table className="table table-striped">
          <thead className="thead tablehead">
            <tr>
              <th scope="col">#</th>
              <th scope="col">Image</th>
              <th scope="col">Name</th>
              <th scope="col">Email</th>
              <th scope="col">Phone</th>
              <th scope="col">Gender</th>
              <th scope="col">Status</th>
              <th scope="col">Option</th>
            </tr>
          </thead>
          {isSearching ? (
            <i className="fas fa-spinner fa-pulse fa-2x "></i>
          ) : UserList.length === 0 ? (
            <tbody>
              <tr>
                <td>No User Found</td>
              </tr>
            </tbody>
          ) : (
            <tbody className="tablebody">
              {UserList &&
                UserList.map((p) => {
                  count++;
                  // let date = new Date(p.timeStamp.toDate());
                  // const createdTime = `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
                  // const createdDate = `${date.getDate()}/${
                  //   date.getMonth() + 1
                  // }/${date.getFullYear()}`;
                  return (
                    <tr key={p.uid}>
                      <td className="align-middle">{count}</td>
                      <td className="align-middle">
                        {p.imageUrl === "" ? (
                          <div className="userbg">
                            <i className="fa fa-user fa-2x"></i>
                          </div>
                        ) : (
                          <img className="image" alt="" srcSet={p.imageUrl} />
                        )}
                      </td>
                      <td className="align-middle">{p.fullName}</td>
                      <td className="align-middle">{p.email}</td>

                      <td className="align-middle">{p.mobileNo}</td>
                      <td className="align-middle">{p.gender}</td>
                      <td className="align-middle">
                        {/* <button disabled={p.status?"true":""} className="add-item__button" ></button> */}

                        <div className="wrg-toggle">
                          <div className="wrg-toggle-container">
                            {p.status ? "true" : ""}
                            <div className="wrg-toggle-check">
                              <span>🌜</span>
                            </div>
                            <div className="wrg-toggle-uncheck">
                              <span>🌞</span>
                            </div>
                          </div>
                          <div className="wrg-toggle-circle"></div>
                          <input
                            className="wrg-toggle-input"
                            type="checkbox"
                            aria-label="Toggle Button"
                          />
                        </div>
                      </td>

                      <td className="align-middle">
                        <Link to="/edituser">
                          <button
                            onClick={async () => {
                              const sendData = {
                                ...p,
                                collectionName: "users",
                                userId: p.userid,
                              };

                              props.setOnUserDetails(sendData);
                            }}
                            type="button"
                            className="btn btn-success"
                          >
                            <i className="fa fa-edit" aria-hidden="true"></i>
                          </button>
                        </Link>
                        <button
                          type="button"
                          className="btn btn-danger"
                          onClick={() => {
                            console.log(p.userid);
                            handleOnDelete(p.name, p.userid);
                          }}
                        >
                          <i className="fa fa-trash" aria-hidden="true"></i>
                        </button>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          )}
        </table>

        <div className="loadmoredatasection">
          {isLoadMoreData ? (
            <i className="fas fa-spinner fa-pulse fa-2x loadmoredataspinner"></i>
          ) : (
            <div className="nomoredatatext">{noMoreDataText}</div>
          )}
          {UserList.length === 0 ? null : isSearchDataShow ? null : (
            <button
              type="button"
              className="btn btn-warning"
              onClick={() => showMore()}
            >
              Show More
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

const mapDisptachToProps = (dispatch) => {
  return {
    setOnUserDetails: (p) => {
      dispatch(setuser(p));
    },
  };
};

export default connect(null, mapDisptachToProps)(UserList);
